<template>
  <layout title="Users">
    <div class="row mb-4">
      <div class="col-10 col-sm-9">
        <h2 class="page-heading">Reports / Attendance</h2>
      </div>

      <div class="col-2 col-sm-3"></div>
    </div>
    <div class="card shadow-sm p-3 mb-5 bg-white rounded mt-2">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12 x-offset-5 mb-3">
            <form
              @submit.prevent="generateReport()"
              class="needs-validation"
              novalidate
            >
              <div class="form-row">
                <div class="col-md-3 mb-3">
                  <label for="validationCustom01">Classroom</label>
                  <select
                    v-model="filters.classroom_id"
                    name="classroom"
                    class="form-control"
                    id=""
                    @change="getStudents()"
                  >
                    <option value="">All</option>
                    <option
                      v-for="classroom in classrooms.data"
                      :key="classroom.id"
                      :value="classroom.id"
                    >
                      {{ classroom.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="validationCustom02">Student</label>
                  <select
                    v-model="filters.student_id"
                    name="student"
                    class="form-control"
                    id=""
                    :disabled="students_text_box_disabled"
                  >
                    <option value="">All</option>
                    <option
                      v-for="student in students"
                      :key="student.id"
                      :value="student.id"
                    >
                      {{ `${student.first_name} ${student.last_name}` }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="validationCustom02">Report type</label>
                  <select
                    v-model="filters.report_type"
                    name="report_type"
                    class="form-control"
                    @change="resetReportData()"
                  >
                    <option value="attendance_records">All Records</option>
                    <option value="attendance_summary">Attendance Summary</option>
                  </select>
                </div>
                <div class="col-md-3 mb-3">
                  <label for="">&nbsp;</label>
                  <div class="input-group">
                    <button class="btn btn-primary" type="submit">
                      Generate
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <table class="table table-hover table-responsive w-100 d-md-table">
              <thead class="thead-light xthead-dark">
                <tr v-if="filters.report_type == 'attendance_records'">
                  <th scope="col">Date</th>
                  <th scope="col">Classroom</th>
                  <th scope="col">Student ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Status</th>
                </tr>

                <tr v-if="filters.report_type == 'attendance_summary'">
                  <th scope="col">Classroom</th>
                  <th scope="col">Student ID</th>
                  <th scope="col">Name</th>
                  <th scope="col">Attendance</th>
                </tr>


              </thead>
              <tbody v-if="filters.report_type == 'attendance_records'">
                <tr
                  v-for="attendance_record in report_data.data"
                  :key="attendance_record.id"
                >
                  <td>{{ attendance_record.created_at }}</td>
                  <td>{{ attendance_record.classroom.name }}</td>
                  <td>{{ attendance_record.user.student_id }}</td>
                  <td>
                    {{
                      attendance_record.user.first_name +
                      " " +
                      attendance_record.user.last_name
                    }}
                  </td>
                  <td>{{ attendance_record.status }}</td>
                </tr>
              </tbody>

              <tbody v-if="filters.report_type == 'attendance_summary'">
                <tr
                  v-for="attendance_record in report_data.data"
                  :key="attendance_record.id"
                >
                  <td>{{ attendance_record.classroom.name }}</td>
                  <td>{{ attendance_record.user.student_id }}</td>
                  <td>
                    {{
                      attendance_record.user.first_name +
                      " " +
                      attendance_record.user.last_name
                    }}
                  </td>
                  <td>{{ parseFloat(attendance_record.user_attendance).toFixed(2) }}%</td>
                </tr>
              </tbody>
              <tbody v-if="!report_data.data || !report_data.data.length">
                <tr>
                  <td :colspan="filters.report_type == 'attendance_records' ? 5 : 4">No data to display</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-end">
                <li
                  class="page-item"
                  :class="{ active: link.active }"
                  v-for="link in report_data.meta.links"
                  :key="link.label"
                >
                  <inertia-link
                    v-if="link.url"
                    class="page-link"
                    :href="link.url"
                    preserve-scroll
                  >
                    <span v-html="link.label"></span>
                  </inertia-link>
                  <span class="page-link" v-else>
                    <span v-html="link.label"></span>
                  </span>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
import AppLayout from "../Layouts/AppLayout";

export default {
  layout: AppLayout,
  props: {
    classrooms: Object,
    filters: {
      classroom_id: String,
      student_id: String,
      report_type: 'attendance_records'
    },
    report_data: Object,
  },
  data() {
    return {
      students_text_box_disabled: true,
      students: [],
    };
  },
  methods: {
    getStudents() {
      this.students_text_box_disabled = true;
      this.filters.student_id = "";
      if (this.filters.classroom_id) {
        $.get(
          route("classrooms.students.list", this.filters.classroom_id)
        ).then((res) => {
          this.students_text_box_disabled = false;
          this.students = res.data;
        });
      }
    },
    generateReport() {
      const reqParams = {};

      reqParams["classroom_id"] = this.filters.classroom_id || undefined;
      reqParams["student_id"] = this.filters.student_id || undefined;
      reqParams["report_type"] = this.filters.report_type || undefined;

      this.$inertia.get(route("reports.attendance"), reqParams, {
        preserveState: true,
        preserveScroll: true,
        only: ["report_data", "filters"],
      });
    },
    resetReportData() {
        this.report_data.data = [];
        
    }
  },
};
</script>